<template>
  <div
    class="bg-page-loader"
    :class="overlayClass"
    role="status"
    aria-live="polite"
    :aria-label="text"
  >
    <div class="bg-page-loader__panel">
      <div
        v-if="showLoaderImage"
        class="bg-page-loader__logo-mark"
      >
        <div
          class="bg-page-loader__logo-c bg-page-loader__logo-c--full"
          aria-hidden="true"
        >
          <img
            :src="configuredLoaderUrl"
            alt=""
            class="bg-page-loader__logo-c-img bg-page-loader__logo-c-img--full"
          >
        </div>
      </div>
      <p class="bg-page-loader__text">{{ text }}</p>
      <div class="bg-page-loader__bar" aria-hidden="true">
        <span class="bg-page-loader__bar-fill" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resolveSiteLoadingLogoUrl } from '@/utils/siteBrand'

export default {
  name: 'BlackGoldPageLoader',
  props: {
    text: {
      type: String,
      default () {
        return this.$t('common.loading')
      }
    },
    overlayClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loaderImageReady: false,
      loaderImgError: false
    }
  },
  computed: {
    ...mapState(['siteInfo']),
    configuredLoaderUrl () {
      return resolveSiteLoadingLogoUrl(this.siteInfo)
    },
    showLoaderImage () {
      return Boolean(this.configuredLoaderUrl && this.loaderImageReady && !this.loaderImgError)
    }
  },
  watch: {
    configuredLoaderUrl: {
      immediate: true,
      handler (url) {
        this.loaderImageReady = false
        this.loaderImgError = false

        if (!url) return

        const img = new Image()
        img.onload = () => {
          if (this.configuredLoaderUrl === url) {
            this.loaderImageReady = true
          }
        }
        img.onerror = () => {
          if (this.configuredLoaderUrl === url) {
            this.loaderImgError = true
          }
        }
        img.src = url
      }
    }
  }
}
</script>
